import api from "../../services/api";
import { obterIdTenent } from "../../services/seguranca";
import { Lancamento, Pagamento } from "../../services/tipos";
import { emLotesDe } from "../pdf/abrir-pdf";
import { gerarQrCodePng } from "../pdf/qrcode-png";
import { PixFatura, lancamentoEmAberto, pagamentoEmAberto } from "./fatura-dados";

const pixDoCodigo = async (copiaECola: string | null | undefined): Promise<PixFatura | null> => {
    const codigo = (copiaECola ?? "").toString().trim();
    if (!codigo) return null;
    return { copiaECola: codigo, imagem: await gerarQrCodePng(codigo) };
};

export const carregarPixDosPagamentos = async (pagamentos: Pagamento[]): Promise<Record<string, PixFatura>> => {
    const resultado: Record<string, PixFatura> = {};
    const abertos = pagamentos.filter(p => p.id && pagamentoEmAberto(p));
    const pixes = await emLotesDe(abertos, CONCORRENCIA, async (p) => {
        try {
            const rota = p.asaasPaymentId ? `/Pagamento/PixAsaas/${p.id}` : `/Pagamento/PixCopiaCola/${p.id}`;
            const response = await api.get(rota);
            return { id: p.id!, pix: await pixDoCodigo(response.data) };
        } catch {
            return { id: p.id!, pix: null };
        }
    });
    pixes.forEach(r => {
        if (r.pix) resultado[r.id] = r.pix;
    });
    return resultado;
};

export const carregarPixPorValor = async (valor: number, idFilial?: string | null): Promise<PixFatura | null> => {
    if (!(valor > 0)) return null;
    try {
        const params = new URLSearchParams({ valor: valor.toFixed(2) });
        if (idFilial) params.append("idFilial", idFilial);
        const response = await api.get(`/Pagamento/PixPorValor?${params.toString()}`);
        return await pixDoCodigo(response.data);
    } catch {
        return null;
    }
};

export const carregarPixDosLancamentos = async (lancamentos: Lancamento[]): Promise<Record<string, PixFatura>> => {
    const resultado: Record<string, PixFatura> = {};
    const abertos = lancamentos.filter(l => l.id && lancamentoEmAberto(l));
    const pixes = await emLotesDe(abertos, CONCORRENCIA, async (l) => {
        try {
            const response = await api.get(`/Pagamento/PixCopiaCola/${l.id}`);
            return { id: l.id!, pix: await pixDoCodigo(response.data) };
        } catch {
            return { id: l.id!, pix: null };
        }
    });
    pixes.forEach(r => {
        if (r.pix) resultado[r.id] = r.pix;
    });
    return resultado;
};

const CONCORRENCIA = 6;

export const carregarLocacoesPorId = async (ids: string[]): Promise<Record<string, any>> => {
    const locacoes: Record<string, any> = {};
    const resultados = await emLotesDe(ids, CONCORRENCIA, async (id) => {
        try {
            const response = await api.get(`/locacao/${id}`);
            return { id, locacao: response.data };
        } catch {
            return { id, locacao: null };
        }
    });
    resultados.forEach(r => {
        if (r.locacao) locacoes[r.id] = r.locacao;
    });
    return locacoes;
};

export const carregarEmpresaDoToken = async (token: string): Promise<any> => {
    try {
        const response = await api.get(`/Empresa/${obterIdTenent(token)}`);
        return response.data;
    } catch {
        return null;
    }
};

export const carregarValoresDeCobranca = async (idsPagamento: string[]): Promise<Record<string, number>> => {
    const valores: Record<string, number> = {};
    const resultados = await emLotesDe(idsPagamento, CONCORRENCIA, async (id) => {
        const response = await api.get(`/Pagamento/ValorCobranca/${id}`);
        return { id, valor: Number(response.data) };
    });
    resultados.forEach(r => {
        if (!isNaN(r.valor)) valores[r.id] = r.valor;
    });
    return valores;
};
